// Keeps a shared deep link (e.g. /help#formas-de-entrar-4) through the sign-in redirect.
// sessionStorage, so it lives only in the tab that opened the link.
export const RETURN_TO_KEY = 'coco_return_to';

const ENTRY_PATHS = new Set(['/', '/signin']);

export const isSafeReturnPath = path =>
  typeof path === 'string' &&
  path.startsWith('/') &&
  !path.startsWith('//') &&
  !path.includes('\\') &&
  !ENTRY_PATHS.has(path.split(/[?#]/)[0]);

export const rememberReturnTo = location => {
  if (!location) return;
  const path = `${location.pathname || ''}${location.search || ''}${location.hash || ''}`;
  try {
    if (isSafeReturnPath(path)) sessionStorage.setItem(RETURN_TO_KEY, path);
  } catch {
    // Storage can be unavailable (private mode); the link then simply lands on the home page.
  }
};

export const consumeReturnTo = () => {
  try {
    const path = sessionStorage.getItem(RETURN_TO_KEY);
    sessionStorage.removeItem(RETURN_TO_KEY);
    return isSafeReturnPath(path) ? path : null;
  } catch {
    return null;
  }
};
